export const fragenRestwertfinanzierungAutoVerkaufen = [
  {
    question: "Kann ich eine Restwertfinanzierung vorzeitig ablösen?",
    answer: (
      <>
        <p>
          Ja, aber die Bank kann eine Vorfälligkeitsentschädigung verlangen. Ob
          sich die Ablösung lohnt, hängt von der Restschuld und dem aktuellen
          Zinsniveau ab.
        </p>
      </>
    ),
  },
  {
    question:
      "Was passiert, wenn der tatsächliche Restwert unter dem kalkulierten liegt?",
    answer: (
      <>
        <p>
          Bei Rückgabe musst du die Differenz zahlen. Verkaufst du selbst, trägst
          du das Risiko ebenfalls.
        </p>
      </>
    ),
  },
  {
    question: "Lohnt sich eine Restwertfinanzierung bei Elektroautos?",
    answer: (
      <>
        <p>
          Elektroautos verlieren derzeit weniger an Wert als manch ältere
          Verbrenner, aber die Marktpreise schwanken. Gerade wegen technologischer
          Sprünge solltest du den kalkulierten Restwert kritisch prüfen.
        </p>
      </>
    ),
  },
  {
    question: "Ist Leasing nicht ähnlich?",
    answer: (
      <>
        <p>
          Beim Leasing besitzt du das Auto nie. Bei der Restwertfinanzierung hast
          du die Option, Eigentümer zu werden. Beide Modelle arbeiten jedoch mit
          kalkulierten Restwerten.
        </p>
      </>
    ),
  },
];

